import { useEffect, useRef } from 'preact/hooks';
import { useAsyncAction } from '../../hooks/use-async-action';
import { getStats } from '../../api/stats';
import { getHealth } from '../../api/health';
import { Card } from '../../components/card';
import { MetricsStrip } from './metrics-strip';
import { DataQualityPanel } from './data-quality-panel';
import { EnhancedActivityFeed } from './enhanced-activity-feed';
import { SystemSummary } from './system-summary';
import { QuickActionsGrid } from './quick-actions-grid';

interface OverviewTabProps {
  onNavigate: (hash: string) => void;
}

export function OverviewTab({ onNavigate }: OverviewTabProps) {
  const mounted = useRef(false);
  const stats = useAsyncAction(getStats);
  const health = useAsyncAction(getHealth);

  useEffect(() => {
    if (mounted.current) return;
    mounted.current = true;
    stats.execute();
    health.execute();
  }, []);

  return (
    <div>
      {/* Metrics Strip — 6 stat cards across the top */}
      <MetricsStrip
        stats={stats.result}
        health={health.result}
        onNavigate={onNavigate}
      />

      {/* Two-column layout: Activity Feed + Data Quality / System */}
      <div class="overview-grid">
        {/* Left: Activity Feed */}
        <Card>
          <h2>Recent Activity</h2>
          <EnhancedActivityFeed />
        </Card>

        {/* Right: Data Quality + System Health */}
        <div>
          <Card>
            <h2>Data Quality</h2>
            <DataQualityPanel stats={stats.result} />
          </Card>

          <Card>
            <h2>System Health</h2>
            <SystemSummary
              health={health.result}
              loading={health.loading}
              onNavigate={onNavigate}
            />
          </Card>
        </div>
      </div>

      {/* Quick Actions — 2x3 grid */}
      <Card>
        <h2>Quick Actions</h2>
        <QuickActionsGrid onNavigate={onNavigate} />
      </Card>
    </div>
  );
}
